<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" :rules="rules" ref="form" label-width="120px"
        v-loading="loading">
        <el-row :span="24">

          <el-col :span="24">
            <el-form-item prop="title" label="标题">
              <el-input clearable v-model="formData.title" placeholder="请输入标题" />

            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item prop="content" label="记录内容">
              <el-input type="textarea" v-model="formData.content" placeholder="请输入记录内容" />

            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item prop="fileList" label="附件">
              <file-upload v-model="formData.fileList" :maxSize="50"></file-upload>

            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
              <el-button type="primary" @click="submit">提交</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

    </custom-actions>

  </div>
</template>

<script>

export default {
  name: 'eventRecordAdd',

  data () {
    return {
      formData: {

        title: '',
        content: '',
        fileList: []
      },

      rules: {

        title: [
          {
            required: true,
            message: '请输入标题',
            trigger: ['blur', 'change']
          }
        ],
        content: [
          {
            required: true,
            message: '请输入记录内容',
            trigger: ['blur', 'change']
          }
        ]

      },
      loading: false,
      userList: []

    }
  },
  created () {
    if (this.eventId) {
      this.loadData()
    }
  },
  computed: {
    eventId () {
      return this.$route.query.eventId
    }

  },
  methods: {

    loadData () {
      this.loading = true
      this.$axios
        .get(this.$apis.eventRecord.selectYgnEventByEventId, {
          params: { eventId: this.eventId }
        })
        .then(res => {
          res.fileList = res.fileList ? res.fileList : []
          this.formData = res
        })
        .finally(() => {
          this.loading = false
        })
    },

    submit () {
      this.$refs.form
        .validate()
        .then(() => {
          this.loading = true

          let url = this.$apis.eventRecord.insertYgnEvent
          if (this.eventId) {
            url = this.$apis.eventRecord.updateYgnEvent
          }

          this.$axios.post(url, { ...this.formData }).then(() => {
            this.$router.back()
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-input,
  .el-cascader,
  .el-date-editor {
    width: 100%;
    max-width: 400px;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}

</style>
